/**
 * Comparte el estado del selector de elementos entre el botón del panel de IA y el marco
 * de la página. Las runas actualizan ambos componentes sin pasar la opción por
 * componentes intermedios.
 *
 * Este módulo solo conserva si el selector está activo. El elemento elegido se comunica
 * como evento y se guarda en la conversación de su página.
 */
import type { PickedBlock } from "@shared/types";

let active = $state(false);

/** Si el cursor está encendido, para quien lo dibuje. */
export const picker = {
  get active(): boolean {
    return active;
  },
};

/** Encender o apagar el cursor. */
export function setPickerActive(next: boolean): void {
  active = next;
}

const takers = new Set<(block: PickedBlock) => void>();

/** El puente senalo un elemento. */
export function emitPicked(block: PickedBlock): void {
  for (const fn of takers) fn(block);
}

/** Quedarse con lo que se vaya señalando. */
export function onPicked(fn: (block: PickedBlock) => void): () => void {
  takers.add(fn);
  return () => {
    takers.delete(fn);
  };
}

let counter = 0;
/** Id de un elemento señalado en la página. */
export const nextPickId = () => `p${++counter}`;
